<div class="container container-shadow pt-4 pb-5 my-4 mb-4">
  <h3 class="text-center">Stylesheets</h3>
  <div class="row mb-4">
    <div class="col-md-4"><a type="button" class="btn btn-primary" routerLink="/stylesheets/new" routerLinkActive="active">New</a></div>
    <div class="col-md-4 offset-md-4">
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">Stylesheet Name</span>
        </div>
        <input type="text" name='search_term' ngDefaultControl class="form-control" placeholder="Name" [(ngModel)]="searchTerm" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }" />
        <div class="input-group-append">
          <button class="btn btn-outline-secondary" type="button" (click)="searchStylesheets()"><i class="fas fa-search"></i></button>
        </div>
      </div>
    </div>
  </div>
  <div class="row mb-4">
    <div class="col">
      <table class="table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Name</th>
            <th>Content</th>
            <th>Group</th>
            <th>Edit</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let stylesheet of stylesheets">
            <td>{{ stylesheets.indexOf(stylesheet) + 1 }}</td>
            <td>{{ stylesheet.name }}</td>
            <td>{{ shortenStylesheetContent(stylesheet.content) }}</td>
            <td>{{ stylesheet.group_name }}</td>
            <td><a type="button" class="btn btn-light" routerLink="/stylesheets/{{ stylesheet.id }}/edit">Edit</a></td>
            <td>
              <button type="button" class="btn btn-danger" (click)="deleteStyleSheet(stylesheet.id, stylesheet)" [disabled]="stylesheet.isDeleting">
                {{ stylesheet.isDeleting ? 'Deleting' : 'Delete' }}<span *ngIf="stylesheet.isDeleting">&nbsp;<i class="fas fa-spinner fa-pulse fa-fw"></i></span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <pagination
    (pageChanged)="loadStylesheets($event)"
    class="pagination-sm"
    [boundaryLinks]="true"
    [totalItems]="stylesheetsMaxCount"
    [maxSize]="paginateParams.per_page"
    name='search_params_page'
    ngDefaultControl
    [(ngModel)]="paginateParams.page"
    [itemsPerPage]="paginateParams.per_page"
    previousText="&lsaquo;"
    nextText="&rsaquo;"
    firstText="&laquo;"
    lastText="&raquo;"
  ></pagination>
</div>
